import type { CustomDetector } from 'i18next-browser-languagedetector';

import { parseLanguagePath } from '@/modules/routing';

// The language of the URL's first segment (`/ru/cookbook`); read-only, the remembered language is localStorage's
const urlLanguageDetector: CustomDetector = {
    name: 'urlPath',
    lookup: () => parseLanguagePath(window.location.pathname).lang,
};

export default urlLanguageDetector;
